import React from 'react';
import { Col } from 'reactstrap';
import DataTable from '../../../../../components/Core/DataTable';
import { PagedMetaInterface } from '../../../../../entities/PagedMeta';

interface SubmittedTabProps {
  columns: any[];
  data: any[];
  pagedMeta: PagedMetaInterface;
  loading: boolean;
  handlePerRowsChange: (perPage: number) => Promise<void>;
  handlePageChange: (page: number) => Promise<void>;
}

const SubmittedTab = ({
  columns,
  data,
  pagedMeta,
  loading,
  handlePerRowsChange,
  handlePageChange,
}: SubmittedTabProps) => {
  return (
    <Col xs="12">
      <DataTable
        columns={columns}
        data={data}
        header={false}
        totalRows={pagedMeta.total}
        loading={loading}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />
    </Col>
  );
};

export default SubmittedTab;
